div {
	/* Flex */
	display: flex;
	align-items: center;
	gap: 10px;

	/* Position */
	position: fixed;
	top: 10px;
	left: 50%;
	transform: translate(-50%, calc(-100% - 20px));
	z-index: 10;

	/* Spacing */
	padding: 15px 20px 15px 20px;

	/* Border */
	border-radius: 5px;
	border-style: solid;
	border-width: 1px;
	border-color: var(--border-color);
	box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1), 0 3px 6px rgba(0, 0, 0, 0.08);
}

img {
	/* Color */
	color: red;

	/* Dimensions */
	width: 24px;
	height: 24px;
}

p {
	margin: 0px;
}

@keyframes slideIn {
	from {
		transform: translate(-50%, calc(-100% - 20px));
	}
	to {
		transform: translate(-50%, 0);
	}
}

@keyframes slideOut {
	from {
		transform: translate(-50%, 0);
	}
	to {
		transform: translate(-50%, calc(-100% - 20px));
	}
}